import Joi from 'joi'

const forgotPasswordValidator = Joi.object({
  email: Joi.string()
    .email({tlds: {allow: false}})
    .required()
    .messages({
      'string.empty': 'Email is required',
      'string.email': 'Invalid email format'
    })
})

export {forgotPasswordValidator}
